import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { ProsumerBonusState } from './types';

export const getters: GetterTree<ProsumerBonusState, RootState> = {}
